import { render, staticRenderFns } from "./DialogCardBase.vue?vue&type=template&id=c2cd100a"
import script from "./DialogCardBase.vue?vue&type=script&lang=js"
export * from "./DialogCardBase.vue?vue&type=script&lang=js"
import style0 from "./DialogCardBase.vue?vue&type=style&index=0&id=c2cd100a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports